// extracted by mini-css-extract-plugin
module.exports = {"container":"CdsamAddressesFooter_container__37Eez","button":"CdsamAddressesFooter_button__2FN7v","button-ltr":"CdsamAddressesFooter_button-ltr__2lRZF"};